import { render, staticRenderFns } from "./LightDALI.vue?vue&type=template&id=1e20a6e6&scoped=true&"
import script from "./LightDALI.vue?vue&type=script&lang=js&"
export * from "./LightDALI.vue?vue&type=script&lang=js&"
import style0 from "./LightDALI.vue?vue&type=style&index=0&id=1e20a6e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e20a6e6",
  null
  
)

export default component.exports